import { StyleSheet, Text, View, Image } from 'react-native'
import React from 'react'

const WelcomeFifth = () => {
  return (
    <>
      <Text
        style={{
          fontWeight: 'bold',
          fontSize: 27,
          color: 'white',
          alignSelf: 'center'
        }}
      > Onboarding</Text>
      <Image
        source={require('../../../static/images/Welcome-HomeScreen.png')}
        style={[styles.appBrand]}
        resizeMode="contain"
      />
    </>

  )
}

export default WelcomeFifth

const styles = StyleSheet.create({
  rectangle: {
    alignSelf: 'center',
    marginTop: '20%',
    width: '30%',
    height: '64%',
    //backgroundColor: 'white',
    borderRadius: 15
  },
  appBrand: {
    width: '50%',
    height: '70%',
    alignSelf: 'center'
    // marginTop:'10%'
  }
})
